<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar">
<p class="aut">The Berenson Family Decision-Making Rules</p>
<p class="noindent2"><i>If you are Jack, don’t assume the worst will happen. Imagine what Richard and Claire would do and then take out the life-threatening parts.</i></p>
<p class="noindent2"><i>If you are Richard and Claire, don’t assume everything will be fine. Try to imagine what Jack would do. If Jack would never do what you’re thinking about doing, that is a warning sign!</i></p>
<p class="noindent2"><i>If we all follow the rules, we will probably survive.</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm2.vue?62f98cab